import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IonContent } from '@ionic/react';

import { screen } from '$fcomponents/hoc';
import { TableView2, Header } from '$gcomponents/widgets';

import { IonPageWrapper } from './styles';
import FactoryModel from '$fbusiness/models/factory';
import CurrentStateModel from '$fbusiness/models/currentState';
import ItemActionModel from '$gbusiness/models/itemAction';
import { factoryActions } from '$fbusiness/redux/factory';
import { dialog } from '$gcomponents/reusables';
import { configs } from '$configs';
import FabButton from '$fcomponents/fabButton';
import { accessHide, getAccess, isAccessible } from '$fbusiness/helpers/util';
import { INVOICE_TYPE_TABLE, INVOICE_TYPE_TABLE_CONFIG } from './invoiceTypeTable';
import InvoiceTypeEditModal from './invoiceTypeEditModal';
import { initialInvoiceType } from '$fbusiness/models/invoiceType';

interface InvoiceTypesScreenProps {
  factory: FactoryModel;
  deleteObj: Function;
  currentState: CurrentStateModel;
}

const InvoiceTypesScreen: React.FC<InvoiceTypesScreenProps> = ({ factory, deleteObj, currentState }) => {
  const [invoiceType, setInvoiceType] = useState<any>(null);

  const ACCESS = getAccess(currentState);

  if (!factory) return <IonPageWrapper />;
  const { invoiceTypes } = factory;

  const onCloseModal = async () => {
    setInvoiceType(null);
  };

  const itemActions: Array<ItemActionModel> = [
    {
      label: 'BUTTON.EDIT',
      eventName: 'editItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.TERM.EDIT, currentState),
      onClick: setInvoiceType,
    },
    {
      label: 'BUTTON.DELETE',
      eventName: 'deleteItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.TERM.DELETE, currentState),
      onClick: (row) => {
        dialog.confirm({
          message: 'MESSAGE.DELETE_INVOICE_TYPE_WARNING',
          onPress: async () => {
            await deleteObj(row.id, configs.api.invoiceType, factoryActions.fetchInvoiceTypes);
          },
        });
      },
    },
  ];

  return (
    <IonPageWrapper>
      <Header title="SCREEN.INVOICE_TYPES.TITLE" />
      <IonContent>
        <TableView2
          data={invoiceTypes}
          tableConfig={INVOICE_TYPE_TABLE_CONFIG}
          TABLE={INVOICE_TYPE_TABLE()}
          itemActions={itemActions}
        />
      </IonContent>
      <InvoiceTypeEditModal invoiceType={invoiceType} onClose={onCloseModal} />
      <FabButton
        onClick={() => setInvoiceType(initialInvoiceType)}
        className={accessHide(ACCESS.ACTION.SETTING.TERM.CREATE)}
      />
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  factory: state.factory.factory,
  resetOnRoute: true,
});

const mapDispatchToProps = {
  deleteObj: factoryActions.deleteObj,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(InvoiceTypesScreen));
